module.exports = __webpack_public_path__ + "static/media/invest.0b138d1e.JPG";